<div class="sidenav-group" [attr.data-group-id]="group.id">
  <!-- Group Header -->
  <div
    class="sidenav-group-header"
    [class.clickable]="group.isCollapsible !== false"
    [class.collapsed]="isCollapsed"
    (click)="onGroupHeaderClick()"
    [attr.aria-expanded]="isExpanded$ | async"
    [attr.aria-controls]="'group-items-' + group.id"
    role="button"
    tabindex="0"
    (keydown.enter)="onGroupHeaderClick()"
    (keydown.space)="onGroupHeaderClick()"
  >
    <span class="group-label">
      {{ group.label | fallbackTranslate }}
    </span>
    <i
      *ngIf="group.isCollapsible !== false && !isCollapsed"
      class="fa fa-chevron-down group-chevron"
      [class.rotated]="!(isExpanded$ | async)"
      aria-hidden="true"
    ></i>
  </div>

  <!-- Group Items -->
  <div
    class="sidenav-group-items"
    [id]="'group-items-' + group.id"
    [class.expanded]="isExpanded$ | async"
    [class.collapsed-sidebar]="isCollapsed"
    [@slideToggle]="(isExpanded$ | async) ? 'expanded' : 'collapsed'"
  >
    <div
      *ngFor="let item of getVisibleItems(); trackBy: trackByItemId"
      class="sidenav-item"
      [class.active]="isItemActive(item)"
      [class.locked]="isItemLocked(item)"
      [class.has-animation]="item.hasAnimation"
      [class.sidebar-collapsed]="isCollapsed"
      [attr.data-item-id]="item.id"
      [routerLink]="!isItemLocked(item) && item.route ? item.route : null"
      [tabindex]="isItemLocked(item) ? -1 : 0"
      (click)="onItemClick(item, $event)"
      (keydown.enter)="onItemClick(item, $event)"
      (keydown.space)="onItemClick(item, $event)"
      role="button"
      [attr.aria-label]="item.label | fallbackTranslate"
      [attr.aria-disabled]="isItemLocked(item)"
    >
      <!-- Icon and Lock Overlay -->
      <div class="item-icon-container">
        <img
          [src]="getItemIcon(item)"
          [alt]="item?.label | fallbackTranslate"
          class="item-icon"
          [class.blurred]="isItemLocked(item)"
          loading="lazy"
        />
      </div>

      <!-- Item Content -->
      <div class="item-content" [class.blurred]="isItemLocked(item)">
        <span class="item-label">
          {{ item.label | fallbackTranslate }}
        </span>

        <!-- New Badge -->
        <nz-tag
          *ngIf="item.isNew && !isItemLocked(item)"
          nzColor="#ef2d41"
          class="new-badge zoom"
        >
          {{ 'SIDENAV.NEW' | fallbackTranslate }}
        </nz-tag>

        <!-- Notification Badge -->
        <nz-badge
          *ngIf="getItemBadgeCount(item) > 0 && !isItemLocked(item)"
          nzStandalone
          [nzCount]="getItemBadgeCount(item)"
          [nzOverflowCount]="99"
          class="notification-badge"
        ></nz-badge>
      </div>

      <!-- Lock Indicator -->
      <div
        *ngIf="isItemLocked(item)"
        class="lock-indicator"
        [attr.aria-label]="'SIDENAV.LOCKED' | fallbackTranslate"
      >
        <img
          src="/assets/images/red-lock-icon.svg"
          alt="locked"
          class="lock-icon"
        />
        <span class="lock-text">
          {{ 'SIDENAV.LOCKED' | fallbackTranslate }}
        </span>
      </div>
    </div>
  </div>
</div>
